const listeners = new Set();

export const fetcherEvents = {
  on(cb) {
    listeners.add(cb);
    return () => {
      listeners.delete(cb);
    };
  },
  emit(data) {
    listeners.forEach((cb) => {
      try {
        cb(data);
      } catch (e) {
        console.error("[fetcherEvents] listener error:", e);
      }
    });
  },
  clear() {
    listeners.clear();
  },
};
